// Content for the Permis ATNA « L'analytique » section.
// All dashboard values are illustrative demo data, not measured client results.
export type Bi = { fr: string; en: string }

export const analyticsCopy = {
  eyebrow: { fr: 'L’analytique', en: 'Analytics' },
  line1: { fr: 'Ne mesurez plus', en: 'Don’t just count' },
  line2: { fr: 'seulement les demandes.', en: 'applications.' },
  line3: { fr: 'Comprenez où agir.', en: 'Understand where to act.' },
  bodyLead: { fr: 'Permis ATNA', en: 'ATNA Permits' },
  bodyRest: {
    fr: ' transforme chaque demande de permis, licence ou autorisation en intelligence opérationnelle — pour identifier les blocages, anticiper les besoins et améliorer continuellement le service aux citoyens.',
    en: ' turns every permit, licence or authorization request into operational intelligence — to spot bottlenecks, anticipate needs and continuously improve service to residents.',
  },
  vsPeriod: { fr: 'par rapport à la même période', en: 'vs. same period' },
}

export type KpiKey = 'received' | 'complete' | 'delay' | 'risk' | 'inspections' | 'status'
export type Trend = 'good-up' | 'good-down' | 'bad-up'

export const analyticsKpis: { key: KpiKey; title: Bi; value: Bi; trend: Bi; tone: Trend }[] = [
  { key: 'received', title: { fr: 'Demandes reçues', en: 'Applications received' }, value: { fr: '1 248', en: '1,248' }, trend: { fr: '28 %', en: '28%' }, tone: 'good-up' },
  { key: 'complete', title: { fr: 'Complètes au premier dépôt', en: 'Complete on first submission' }, value: { fr: '72 %', en: '72%' }, trend: { fr: '16 %', en: '16%' }, tone: 'good-up' },
  { key: 'delay', title: { fr: 'Délai moyen de traitement', en: 'Average processing time' }, value: { fr: '14 jours', en: '14 days' }, trend: { fr: '22 %', en: '22%' }, tone: 'good-down' },
  { key: 'risk', title: { fr: 'Dossiers à risque de dépasser le délai cible', en: 'Files at SLA risk' }, value: { fr: '18 %', en: '18%' }, trend: { fr: '12 %', en: '12%' }, tone: 'bad-up' },
  { key: 'inspections', title: { fr: 'Inspections à planifier', en: 'Inspections to schedule' }, value: { fr: '96', en: '96' }, trend: { fr: '34 %', en: '34%' }, tone: 'good-up' },
  { key: 'status', title: { fr: 'Demandes de suivi évitées', en: 'Status inquiries avoided' }, value: { fr: '412', en: '412' }, trend: { fr: '57 %', en: '57%' }, tone: 'good-up' },
]

export type TypeKey = 'reno' | 'parking' | 'rental' | 'pool' | 'public' | 'event'

export const volumeByType: { key: TypeKey; value: number; label: Bi; trend: Bi; color: string; height: number }[] = [
  { key: 'reno', value: 320, label: { fr: 'Rénovation / construction', en: 'Renovation / construction' }, trend: { fr: '24 %', en: '24%' }, color: '#6D4CF0', height: 100 },
  { key: 'parking', value: 286, label: { fr: 'Stationnement', en: 'Parking' }, trend: { fr: '18 %', en: '18%' }, color: '#4B5CF0', height: 90 },
  { key: 'rental', value: 214, label: { fr: 'Location à court terme', en: 'Short-term rental' }, trend: { fr: '42 %', en: '42%' }, color: '#4A8CF2', height: 68 },
  { key: 'pool', value: 168, label: { fr: 'Piscine / terrasse', en: 'Pool / deck' }, trend: { fr: '20 %', en: '20%' }, color: '#4FB7E8', height: 54 },
  { key: 'public', value: 142, label: { fr: 'Occupation du domaine public', en: 'Use of public property' }, trend: { fr: '36 %', en: '36%' }, color: '#3FC7B0', height: 46 },
  { key: 'event', value: 118, label: { fr: 'Événement / permis temporaire', en: 'Event / temporary permit' }, trend: { fr: '29 %', en: '29%' }, color: '#6FD49A', height: 36 },
]

export const processingTimes: { label: Bi; days: number }[] = [
  { label: { fr: 'Rénovation / construction', en: 'Renovation / construction' }, days: 18 },
  { label: { fr: 'Stationnement', en: 'Parking' }, days: 5 },
  { label: { fr: 'Location à court terme', en: 'Short-term rental' }, days: 14 },
  { label: { fr: 'Piscine / terrasse', en: 'Pool / deck' }, days: 12 },
  { label: { fr: 'Domaine public', en: 'Public property' }, days: 16 },
  { label: { fr: 'Événement temporaire', en: 'Temporary event' }, days: 9 },
]

export const funnel: { value: Bi; label: Bi; color: string; width: number }[] = [
  { value: { fr: '1 248', en: '1,248' }, label: { fr: 'Reçues', en: 'Received' }, color: '#9A86F5', width: 100 },
  { value: { fr: '1 015', en: '1,015' }, label: { fr: 'Prévalidées (81 %)', en: 'Pre-validated (81%)' }, color: '#6D7CF4', width: 84 },
  { value: { fr: '812', en: '812' }, label: { fr: 'En analyse (65 %)', en: 'Under review (65%)' }, color: '#5AA2F2', width: 68 },
  { value: { fr: '496', en: '496' }, label: { fr: 'Inspections (40 %)', en: 'Inspections (40%)' }, color: '#72D0C8', width: 52 },
  { value: { fr: '438', en: '438' }, label: { fr: 'Décisions (35 %)', en: 'Decisions (35%)' }, color: '#A9E3A8', width: 40 },
]

export const sectorMarkers: { value: number; x: number; y: number; color: string; size: number }[] = [
  { value: 64, x: 28, y: 26, color: '#3B6BEF', size: 38 },
  { value: 86, x: 72, y: 15, color: '#5B3FE0', size: 40 },
  { value: 42, x: 21, y: 56, color: '#3B6BEF', size: 36 },
  { value: 57, x: 58, y: 55, color: '#4A2FB0', size: 38 },
  { value: 28, x: 36, y: 80, color: '#8EA6F4', size: 34 },
]

export const sectorLegend: { label: Bi; color: string }[] = [
  { label: { fr: '> 50 demandes', en: '> 50 applications' }, color: '#6C2BD9' },
  { label: { fr: '25 – 50 demandes', en: '25 – 50 applications' }, color: '#3B6BEF' },
  { label: { fr: '10 – 25 demandes', en: '10 – 25 applications' }, color: '#6E9CF3' },
  { label: { fr: '< 10 demandes', en: '< 10 applications' }, color: '#5E9C8C' },
]

export const atnaInsight = {
  title: { fr: 'ATNA détecte', en: 'ATNA detects' },
  lead: { fr: '31 %', en: '31%' },
  rest: {
    fr: ' des demandes de location à court terme nécessitent un suivi en raison d’informations manquantes sur la propriété ou la résidence.',
    en: ' of short-term rental applications require follow-up because of missing property or residence information.',
  },
  recoTitle: { fr: 'Recommandation', en: 'Recommendation' },
  recoBody: { fr: 'Vérifier automatiquement ces éléments avant la soumission.', en: 'Automatically verify these items before submission.' },
  impactTitle: { fr: 'Effets attendus', en: 'Expected impact' },
  impacts: [
    { label: { fr: 'Dossiers retournés', en: 'Returned files' }, dir: 'down' },
    { label: { fr: 'Suivis manuels', en: 'Manual follow-ups' }, dir: 'down' },
    { label: { fr: 'Capacité de traitement', en: 'Processing capacity' }, dir: 'up' },
  ] as { label: Bi; dir: 'up' | 'down' }[],
}

export const analyticsBenefits: { key: 'bars' | 'clock' | 'people' | 'target'; title: Bi; body: Bi }[] = [
  { key: 'bars', title: { fr: 'Des décisions mieux éclairées', en: 'Better-informed decisions' }, body: { fr: 'Repérez les goulots d’étranglement et priorisez les actions.', en: 'Spot bottlenecks and prioritize actions.' } },
  { key: 'clock', title: { fr: 'Des délais plus prévisibles', en: 'More predictable timelines' }, body: { fr: 'Mesurez la performance à chaque étape.', en: 'Measure performance at every stage.' } },
  { key: 'people', title: { fr: 'Une meilleure planification', en: 'Better planning' }, body: { fr: 'Anticipez les pics et allouez vos ressources efficacement.', en: 'Anticipate peaks and allocate resources efficiently.' } },
  { key: 'target', title: { fr: 'Une amélioration continue', en: 'Continuous improvement' }, body: { fr: 'Identifiez les causes réelles et suivez les progrès.', en: 'Identify root causes and track progress.' } },
]

export const dashboardMeta = {
  city: 'Clarence-Rockland',
  title: { fr: 'Analytique des permis, licences et autorisations', en: 'Permit, licence and authorization analytics' },
  range: { fr: '1 janv. 2024 – 31 déc. 2024', en: 'Jan 1, 2024 – Dec 31, 2024' },
  panels: {
    volume: { fr: 'Volume de demandes par type', en: 'Application volume by type' },
    times: { fr: 'Délai moyen de traitement par type', en: 'Average processing time by type' },
    funnel: { fr: 'Suivi du traitement des demandes', en: 'Application processing tracking' },
    sectors: { fr: 'Demandes par secteur', en: 'Applications by sector' },
  },
  days: { fr: 'jours', en: 'days' },
}
